export default class Save {
  _id: string
  user_id: string
  post_id: number
  created_at: Date

  constructor(data: Record<string, unknown>) {
    this._id = (data._id as string) ?? ''
    this.user_id = (data.user_id as string) ?? ''
    this.post_id = (data.post_id as number) ?? -1
    this.created_at = new Date(data.created_at as string)
  }
}
